import Amplify from "aws-amplify"
import config from "./src/amplify-config"
import wrapWithProvider from "./wrap-with-provider"

Amplify.configure(config)

export const wrapRootElement = wrapWithProvider
